<template>
    <div class="apiKeySuccess">
        <van-nav-bar v-if="$route.query.isApp != 1" left-arrow @click-left="goCreatedApi" />
        <div class="commont_body">
            <div class="body-title">
                <img src="@/assets/images/apikey/Frame.svg" alt="" />
                <div>
                    <!-- 创建成功 -->
                    {{$t('9100167')}}
                </div>
            </div>
            <div class="body-content">
                <div class="body-content-item">
                    <!-- 备注名 -->
                    <span>{{$t('9100128')}}</span>
                    <span class="left">{{pageData.note}}</span>
                </div>
                <div class="body-content-item">
                    <span>Access Key</span>
                    <div class="code">
                        <span>{{pageData.accessKey.slice(0,24)}}</span>
                        <i class="copy iconfont icon-fuzhi" @click="handleCopy" :data-clipboard-text="pageData.accessKey" :class="[isDirection ? 'mirrorRotateLevel' : '']"></i>
                    </div>
                </div>
                <div class="body-content-item">
                    <span>Secret Key</span>
                    <div class="code">
                        <span>{{pageData.accessSecret.slice(0,24)}}</span>
                        <i class="copy iconfont icon-fuzhi" @click="handleCopy" :data-clipboard-text="pageData.accessSecret" :class="[isDirection ? 'mirrorRotateLevel' : '']"></i>
                    </div>
                </div>
                <div class="body-content-item">
                    <!-- 权限设置 -->
                    <span>{{$t('9100157')}}</span>
                    <!-- 读取 -->
                    <!-- 9100132 交易 -->
                    <span class="left">
                        <!-- {{$t('9100131')}}{{pageData.freeSpotState == 0 ? "、"+ $t('9100132') : ""}} -->
                        {{pageData.freeSpotState == 0 ? $t('9100131') : $t('9100131') +  '、' + $t('9100132')}}
                    </span>
                </div>
                <div class="body-content-itemC">
                    <!-- 绑定IP地址 -->
                    <span>{{$t('9100143')}}</span>
                    <span class="content">{{pageData.whiteList ? pageData.whiteList : "--"}}</span>
                </div>

                <div class="item-line"></div>
                <div class="message">
                    <!-- 9100168  温馨提示 -->
                    <div class="title">{{$t('9100168')}}</div>
                    <!-- · 密钥仅显示一次，遗失后不可找回，请务必妥善保存 -->
                    <span style="color:#D9A31A">· {{$t('9100158')}}</span>
                    <!-- 请不要泄露您的Access Key 及Secret Key，以免造成资产损失 -->
                    <span>· {{$t('9100147')}}</span>
                    <!-- 如您忘记了Secret Key，请删除该密钥对并申请新的密钥 -->
                    <span>· {{$t('9100160')}}</span>
                </div>
            </div>
        </div>
        <!-- <van-popup class="tipModel" :close-on-click-overlay="false" v-model="showDialog">
            <p class="close_icon">
                <svg @click="showDialog = false">
                    <use xlink:href="#icon-guanbi1" />
                </svg>
            </p>
            <p class="p">
                <svg>
                    <use xlink:href="#icon-tishi-1" />
                </svg>
            </p>
            <p class="describe inline-block">
                {{$t('9100158')}}
            </p>
            <div class="sell">
                <Button @click="goCreatedApi">{{
          $t('9100169')
        }}</Button>
            </div>
        </van-popup> -->
    </div>
</template>

<script>
    import { List, Icon, NavBar, Button, Collapse, CollapseItem, Toast } from "vant";
    import { parseTime } from "@/utils/index";
    import { getListdata } from "@/api/resource";
    import { Empty } from "vant";
    import { mapGetters } from "vuex";
    import { removeApiKey, queryApiKey, continueApiKey } from "@/api/apikey";
    import Clipboard from 'clipboard'
    import { setToken, getCookie, removeToken, setCookie } from '../../utils/auth'
import fastjs from 'fastjs-next';

    export default {
        name: "apiKey",
        components: {
            vanList: List,
            vanIcon: Icon,
            vanEmpty: Empty,
            vanNavBar: NavBar,
            Button,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            Toast
        },
        data() {
            return {
                activeNames: ["1"],
                // showDialog: false,
                pageData: {
                    accessKey: '',
                    accessSecret: ''
                },
            };
        },
        watch: {
            $route() {
                this.resher()
            },
        },
        created() {
            console.log(this.$route.query,'this.$route.query---this.$route.query');
            this.resher()
            this.pageData.accessKey = this.$route.query.accessKey
            this.pageData.accessSecret = this.$route.query.accessSecret
            this.getPageList();
        },
        computed: {
            ...mapGetters(["isDirection"])
        },
        methods: {
            goCreatedApi() {
                this.$router.push({
                    path: `/createKey`,
                    query: {
                        backgroundColor: this.$route.query.backgroundColor,
                        language: this.$route.query.language,
                        isApp:this.$route.query.isApp
                    }
                });
            },
            async getPageList() {
                const { data } = await queryApiKey();
                this.pageData = {
                    ...this.pageData,
                    ...(data &&
                        data.length &&
                        data.find(i => i.accessKey == this.pageData.accessKey))
                }
            },
            resher() {
                this.isApp = this.$route.query.isApp
                let token = this.$route.query.token || this.token
                if (token) {
                    setToken(token);
                    this.$store.dispatch('GetInfo', token);
                    this.$store.dispatch('setToken', token);
                }
                setCookie(
                    'language',
                    this.$route.query.language ? this.$route.query.language : 'en'
                )
                this.language = this.$route.query.language
                    ? this.$route.query.language
                    : 'en'
                this.$store.dispatch(
                    'setIsDirection',
                    this.$route.query.language == 'fa' ? true : false
                )
                if (this.$route.query.backgroundColor != '') {
                    window.document.documentElement.setAttribute(
                        'data-theme',
                        this.$route.query.backgroundColor === 'day'
                            ? 'sunlight'
                            : 'moon'
                    )
                } else {
                    window.document.documentElement.setAttribute(
                        'data-theme',
                        'moon'
                    )
                }
                window.document.documentElement.setAttribute(
                    'dir',
                    this.isDirection ? 'rtl' : 'ltr'
                )
            },
            handleCopy() {
                var clipboard = new Clipboard(".copy");
                clipboard.on("success", e => {
                    Toast(this.$t("300027"));
                    // 释放内存
                    clipboard.destroy();
                });
                clipboard.on("error", e => {
                    Toast.fail(this.$t("300028"));
                    // 释放内存
                    clipboard.destroy();
                });
            },
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../assets/css/variableName";
    @import "../../style/mixin";
    @import "../../assets/css/mixin";
    /* 正常 */
    [dir="ltr"] {
        // .tipModel{
        //     .close_icon{
        //         text-align: right;
        //     }
        // }
        
    }
    //镜像
    [dir="rtl"] {
        // .tipModel{
        //     .close_icon{
        //         text-align: left;
        //     }
        // }
        .body-content{
            // float: left
            .code{
                i{
                    float: left;
                }
                span{
                    margin-left: torem(3)
                }
            }
        }
    }
</style>
<style lang="scss" scoped>
    @import "../../assets/css/variableName";
    @import "../../style/mixin";
    @import "../../assets/css/mixin";

    .apiKeySuccess {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        @include background_color("background-color-2");
        /deep/ .van-nav-bar__content {
            @include background_color("background-color-10");
            height: torem(44);
        }
        /deep/ .van-nav-bar__title {
            @include font_color("font-color");
            // color: red;
        }
        /deep/ .van-nav-bar .van-icon {
            @include font_color("font-color");
        }
        /deep/ .van-hairline--bottom::after{
            @include border_color("border-color-6");
        }
        .commont_body {
            width: 100%;
            height: calc(100vh - 44px);
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: torem(16);
            .body-title {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                div {
                    color: #39c66b;
                    font-feature-settings: "clig" off, "liga" off;
                    font-family: "HarmonyOS Sans SC";
                    font-size: torem(16);
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    margin-top: torem(16);
                }
                img {
                    width: torem(60);
                    height: torem(60);
                }
            }
            .body-content {
                width: 100%;
                border-radius: 8px;
                @include background_color("background-color-12");
                padding: torem(24);
                margin-top: torem(24);
                &-item {
                    margin-bottom: torem(16);
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    span {
                        @include font_color("font-color-1");
                        font-family: "HarmonyOS Sans SC";
                        font-size: torem(12);
                        font-style: normal;
                        font-weight: 400;
                        line-height: 100%; /* 24px */
                        white-space: nowrap;
                    }
                    .left {
                        @include font_color("font-color-12");
                        font-family: "Alimama FangYuanTi VF";
                        font-style: normal;
                        font-weight: 500;
                        line-height: normal;
                        // white-space: nowrap;
                    }
                    .code {
                        word-break: break-all;
                        width: 80%;
                        text-align: end;
                        span {
                            @include font_color("font-color-12");
                        }
                        i {
                            @include font_color("font-color-1");
                        }
                    }
                }
                &-itemC {
                    display: flex;
                    flex-direction: column;
                    @include font_color("font-color-1");
                    font-family: "HarmonyOS Sans SC";
                    font-size: torem(12);
                    font-style: normal;
                    font-weight: 400;
                    line-height: 100%; /* 24px */
                    .content {
                        word-wrap: break-word;
                        width: 100%;
                        @include font_color("font-color-12");
                        font-family: "HarmonyOS Sans SC";
                        font-size: torem(12);
                        font-style: normal;
                        font-weight: 400;
                        line-height: 100%; /* 24px */
                        margin-top: torem(8);
                    }
                }
            }
        }

        .item-line {
            width: 100%;
            border-bottom: 2px solid;
            @include border_color("border-color-5");
            margin: torem(20) 0;
        }
        .message {
            display: flex;
            flex-direction: column;
            .title {
                @include font_color("font-color-12");
                font-family: "HarmonyOS Sans SC";
                font-size: torem(14);
                font-style: normal;
                font-weight: 500;
                line-height: 150%; /* 42px */
                letter-spacing: 2px;
            }
            span {
                @include font_color("font-color-2");
                font-family: "HarmonyOS Sans SC";
                font-size: torem(12);
                font-style: normal;
                font-weight: 400;
                line-height: 150%; /* 36px */
                margin-top: torem(8);
            }
        }
    }

    // .tipModel {
    //     // /deep/ .van-popup {
    //     width: calc(100% - 2rem);
    //     min-height: torem(204);
    //     border-radius: torem(8);
    //     padding: torem(24);
    //     @include background_color("background-color-11");
    //     .close_icon{
    //         text-align: right;
    //         svg{
    //             width: torem(15);
    //             height: torem(15);
    //         }
    //     }
    //     .p {
    //         // text-align: center;
    //         display: flex;
    //         justify-content: center;
    //         margin: 0 auto;
    //         svg {
    //             width: torem(48);
    //             height: torem(48);
    //         }
    //     }
    //     .describe {
    //         @include font_color("font-color");
    //         text-align: center;
    //         font-feature-settings: "clig" off, "liga" off;
    //         font-family: "HarmonyOS Sans SC";
    //         // font-size: 28px;
    //         font-style: normal;
    //         font-weight: 400;
    //         line-height: 150%; /* 42px */
    //         font-size: torem(14);
    //         margin: torem(24) 0;
    //     }
    //     .recharge {
    //         font-size: torem(14);
    //         width: 100%;
    //         line-height: torem(21);
    //         height: torem(21);
    //         margin: torem(16) 0 torem(24);
    //         text-align: center;
    //     }
    //     .sell {
    //         /deep/ .van-button {
    //             // width: torem(264);
    //             width: 100%;
    //             height: torem(44);
    //             background: #ffc72b;
    //             border-radius: torem(4);
    //             font-size: torem(16);
    //             color: #000922;
    //         }
    //     }
    //     .modal-title {
    //         display: flex;
    //         align-items: center;
    //         justify-content: center;
    //         svg {
    //             width: torem(16);
    //             height: torem(16);
    //             margin-right: torem(8);
    //         }
    //         span {
    //             color: rgba(0, 0, 0, 0.9);
    //             font-family: "HarmonyOS Sans SC";
    //             font-size: torem(16);
    //             font-style: normal;
    //             font-weight: 500;
    //             line-height: normal;
    //         }
    //     }
    //     .modal-content {
    //         display: flex;
    //         flex-direction: column;
    //         color: rgba(0, 0, 0, 0.9);
    //         font-feature-settings: "clig" off, "liga" off;
    //         font-family: "HarmonyOS Sans SC";
    //         font-size: torem(14);
    //         font-style: normal;
    //         font-weight: 400;
    //         line-height: 150%; /* 42px */
    //         margin: torem(24) 0;
    //         div {
    //             margin: torem(4) 0;
    //         }
    //     }
    // }
</style>



// WEBPACK FOOTER //
// src/view/apiKey/apiKeySuccess.vue